import * as yup from 'yup'

import { store } from 'config/redux'
import { strings } from 'context/LanguageContext/strings'
import { countryCode, getCurrentCountry, isValidUSPhoneNumber } from 'utils/appUtils'
import Util from './Util'

const passwordRegExp = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
const nameRegExp = new RegExp('^[a-zA-Z0-9 ]+$')

yup.addMethod(yup.string, 'userPhoneNumber', errorMsg => {
    return yup.string().test('userPhoneNumber', errorMsg, value => {
        try {
            const digits = value.replace(/[^\d]/g, '')
            const res = isValidUSPhoneNumber(digits)

            return res
        } catch (e) {
            return false
        }
    })
})

const validations = {
    userValidationSchema: facebookUser => {
        const { configuration } = store.getState()
        const { user_name_length, password_length, referral_code_length } = configuration.toJS()
        const { location, user } = store.getState()
        const userCountry = getCurrentCountry(location, user)

        const usValidations = yup.object({
            first_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .matches(nameRegExp, strings.invalidFirstName)
                .trim()
                .required(strings.invalidFirstName),
            last_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .matches(nameRegExp, strings.invalidLastName)
                .trim()
                .required(strings.invalidLastName),
            email: yup.string().matches(Util.getEmailValidationRegEx(), strings.invalidEmail).email(strings.invalidEmail).required(strings.emailError),
            phone_number: yup
                .string()
                .userPhoneNumber(strings.invalidUserPhoneNumber)
                .required(strings.phoneNumberHint),
            password: yup
                .string()
                .matches(passwordRegExp, 'Password is not valid')
                .min(8, `Minimum Password length should be 8`)
                .max(password_length, `Password should be of maximum length ${password_length}`)
                .required(
                    'Common words or phrases will be rejected. Password must contain at least 8 characters, including upper/lowercase letters and a number.'
                ),
            ageConfirmed: yup.bool().oneOf([true], 'Age confirmation is must').required('Required'),
            accepts_ca_terms: yup
                .bool()
                .oneOf([false], 'Accept Terms & Conditions is required')
                .required('Required'),
            accepts_us_terms: yup
                .bool()
                .oneOf([true], 'Accept Terms & Conditions is required')
                .required('Required'),
            referralCode: yup
                .string()
                .min(referral_code_length, strings.applyReferralCodeFailure)
                .max(referral_code_length, strings.applyReferralCodeFailure),
        })
        const usFacebookValidations = yup.object({
            first_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .required(strings.invalidFirstName),
            last_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .required(strings.invalidLastName),
            email: yup.string().email(strings.invalidEmail).required(strings.invalidEmail),
            phone_number: yup
                .string()
                .userPhoneNumber(strings.invalidUserPhoneNumber)
                .required(strings.phoneNumberHint),
            ageConfirmed: yup.bool().oneOf([true], 'Age confirmation is must').required('Required'),
            accepts_ca_terms: yup
                .bool()
                .oneOf([false], 'Accept Terms & Conditions is required')
                .required('Required'),
            accepts_us_terms: yup
                .bool()
                .oneOf([true], 'Accept Terms & Conditions is required')
                .required('Required'),
            referralCode: yup
                .string()
                .min(referral_code_length, strings.applyReferralCodeFailure)
                .max(referral_code_length, strings.applyReferralCodeFailure),
        })
        const canadaValidations = yup.object({
            first_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .matches(nameRegExp, strings.invalidFirstName)
                .trim()
                .required(strings.invalidFirstName),
            last_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .matches(nameRegExp, strings.invalidLastName)
                .trim()
                .required(strings.invalidLastName),
            email: yup.string().email(strings.invalidEmail).required(strings.invalidEmail),
            phone_number: yup
                .string()
                .userPhoneNumber(strings.invalidUserPhoneNumber)
                .required(strings.phoneNumberHint),
            password: yup
                .string()
                .matches(passwordRegExp, 'Password is not valid')
                .min(8, `Minimum Password length should be 8`)
                .max(password_length, `Password should be of maximum length ${password_length}`)
                .required(
                    'Common words or phrases will be rejected. Password must contain at least 8 characters, including upper/lowercase letters and a number.'
                ),
            ageConfirmed: yup.bool().oneOf([true], 'Age confirmation is must').required('Required'),
            accepts_ca_terms: yup
                .bool()
                .oneOf([true], 'Accept Terms & Conditions is required')
                .required('Required'),
            accepts_us_terms: yup
                .bool()
                .oneOf([false], 'Accept Terms & Conditions is required')
                .required('Required'),
            marketingEmailNoty: yup.bool(),
            referralCode: yup
                .string()
                .min(referral_code_length, strings.applyReferralCodeFailure)
                .max(referral_code_length, strings.applyReferralCodeFailure),
        })

        const canadaFacebookValidations = yup.object({
            first_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .required(strings.invalidFirstName),
            last_name: yup
                .string()
                .max(user_name_length, `Must be ${user_name_length} characters or less`)
                .required(strings.invalidLastName),
            email: yup.string().email(strings.invalidEmail).required(strings.invalidEmail),
            phone_number: yup
                .string()
                .userPhoneNumber(strings.invalidUserPhoneNumber)
                .required(strings.phoneNumberHint),
            ageConfirmed: yup.bool().oneOf([true], 'Age confirmation is must').required('Required'),
            accepts_ca_terms: yup
                .bool()
                .oneOf([true], 'Accept Terms & Conditions is required')
                .required('Required'),
            accepts_us_terms: yup
                .bool()
                .oneOf([false], 'Accept Terms & Conditions is required')
                .required('Required'),
            marketingEmailNoty: yup.bool(),
            referralCode: yup
                .string()
                .min(referral_code_length, strings.applyReferralCodeFailure)
                .max(referral_code_length, strings.applyReferralCodeFailure),
        })

        return !facebookUser
            ? userCountry === countryCode.CA
                ? canadaValidations
                : usValidations
            : userCountry === countryCode.CA
              ? canadaFacebookValidations
              : usFacebookValidations
    },
    userProfileValidationSchema: userNameLength =>
        yup.object({
            first_name: yup
                .string()
                .max(userNameLength, `Must be ${userNameLength} characters or less`)
                .matches(nameRegExp, strings.invalidFirstName)
                .trim()
                .required('First name Required'),
            last_name: yup
                .string()
                .max(userNameLength, `Must be ${userNameLength} characters or less`)
                .matches(nameRegExp, strings.invalidLastName)
                .trim()
                .required('Last name Required'),
            email: yup.string().email(strings.invalidEmail).required('Required'),
            phone_number: yup
                .string()
                .userPhoneNumber(strings.invalidUserPhoneNumber)
                .required(strings.phoneNumberHint),
        }),
    emailValidationSchema: () =>
        yup.object({
            email: yup.string().email(strings.invalidEmail).required('Required'),
        }),
}

export default validations
